import { createReducer } from "../../../_common/common.ts";
import {SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS} from "../actions/constants";

const initialState = [];
export const convocation_resignations_academic_programs = createReducer(initialState, {
    [SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS]: (state, payload) => payload
});

